<template>
  <el-drawer v-model="visible" title="人员管理" size="60%">
    <el-table :data="applys" tooltip-effect="dark" border stripe height="calc(100vh - 120px)" v-loading="loading">
      <el-table-column v-for="(column, index) in tableColumns" :key="index" :type="column.type" :prop="column.prop"
        :label="column.label" :width="column.width" :min-width="column.minWidth" :formatter="column.formatter"
        :fixed="column.fixed" :show-overflow-tooltip="column.showTooltip">
      </el-table-column>
      <el-table-column label="审核状态" width="100">
          <template #default="{row}">
            <el-tag v-if="row.auditStatus === 0">待审核</el-tag>
            <el-tag v-else-if="row.auditStatus === 1 && row.userOrgOrUnitId" type="success">审核通过</el-tag>
            <el-tag v-else-if="row.auditStatus && row.userOrgOrUnitId" type="danger">已删除</el-tag>
            <el-tag v-else-if="row.auditStatus === 2" type="warning">审核驳回</el-tag>
          </template>
        </el-table-column>
      <el-table-column label="审核时间" prop="auditTimeString" width="170"></el-table-column>
      <el-table-column label="审核意见" prop="opinion" min-width="170" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="80" fixed="right" v-if="isAuditPower || isDeletePower">
        <template #default="{row}">
          <el-button v-if="isAuditPower && row.auditStatus === 0" type="text" @click="toAudit(row)">审核</el-button>
          <el-button v-if="isDeletePower && row.auditStatus === 1 && row.userOrgOrUnitId" type="text" style="color: red" @click="toDelete(row.userOrgOrUnitId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-drawer>

  <el-dialog v-model="dialogVisible" title="审核" width="30%">
    <span>审核意见</span>
    <el-input type="textarea" :rows="5" maxlength="1000" v-model="apply.opinion"></el-input>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="audit(2)">拒绝</el-button>
        <el-button type="primary" @click="audit(1)">通过</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { defineComponent } from 'vue';
import { deleteOrgUnitUser, getUserApplysByOrgId, getUserApplysByUnitId, userApplyAudit } from '@/api/enterprise/index'
import { deepClone, isHavePower } from '@/utils/common';
export default defineComponent({
  emits: ['get-data'],
  data() {
    return {
      orgUnit: {},
      visible: false,
      dialogVisible: false,
      loading: false,
      applys: [],
      apply: {},
      tableColumns: [
        { type: 'index', width: 55, label: '序号', fixed: 'left' },
        { prop: 'applyUserName', label: '申请人', fixed: 'left', minWidth: 150 },
        { prop: 'phone', label: '手机号', fixed: 'left', width: 120 },
        { prop: 'applyTimeString', label: '申请时间', width: 170 }
      ]
    }
  },
  computed: {
    isAuditPower() { // 审核权限
      return isHavePower('99675173459853636');
    },
    isDeletePower() { // 删除权限
      return isHavePower('99675173459853637');
    }
  },
  methods: {
    show(orgUnit) {
      this.orgUnit = orgUnit;
      this.getData();
      this.visible = true;
    },
    getData() {
      let orgUnit = this.orgUnit;
      if (orgUnit.unitId) {
        this.getApplys(getUserApplysByUnitId, orgUnit.unitId);
      } else {
        this.getApplys(getUserApplysByOrgId, orgUnit.orgId);
      }
    },
    getApplys(requestF, id) {
      this.loading = true;
      requestF(id).then(({data}) => {
        this.applys = data.data;
        this.loading = false;
      }).catch(_ => this.loading = false);
    },
    toAudit(apply) {
      this.apply = deepClone(apply);
      this.dialogVisible = true;
    },
    audit(auditStatus) {
      if (auditStatus === 2 && !this.apply.opinion) {
        this.$message.warning('请填写审核意见');
        return;
      }
      userApplyAudit({
        id: this.apply.id,
        auditStatus,
        opinion: this.apply.opinion
      }).then(({data}) => {
        if (data.status) {
          this.$message.success(data.msg);
          this.dialogVisible = false;
          this.getData();
        } else {
          this.$message.warning(data.msg);
        }
      })
    },
    toDelete(userOrgOrUnitId) {
      this.$confirm('你确定要删除此人', '提示').then(_ => {
        deleteOrgUnitUser(userOrgOrUnitId).then(({data}) => {
          if (data.status) {
            this.$message.success(data.msg);
            this.getData();
          } else {
            this.$message.warning(data.msg);
          }
        })
      }).catch(_ => {})
      
    }
  }
})
</script>
